import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import BuyUsageDataForm from '../forms/BuyUsageDataForm'
import globals from '../globals'

class BuyUsageData extends React.Component {
    constructor (props) {
        super(props)

        this.costPerGb = 10

        this.state = {
            isLoaded: false,
            hasError: false,
            previousDataPurchases: {
                headings: [],
                rows: []
            }
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getPreviousPurchases/${this.props.type}/${this.props.serviceId}`, result => {
            this.setState({
                ...result,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleSuccess (response, state) {
        globals.pushEvent('PurchaseDataBlock', { quantity: state.quantity })
    }

    render () {
        return (
            <div className='buy-usage-data module'>
                <Heading title={this.props.title} />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='px-4'>
                    <div className='row px-md-5 px-2 mt-4'>
                        <div className='col-12 text-center'>
                            <BuyUsageDataForm
                                serviceId={this.props.serviceId}
                                costPerGb={this.costPerGb}
                                display={amount => `${amount * 10}GB`}
                                expires={this.props.expires}
                                handleSuccess={this.handleSuccess.bind(this)}
                                isAnytimeUsage={this.props.serviceDetails.isAnytimeUsage}
                            />
                        </div>
                    </div>
                    <div className='row mt-5 px-md-5 px-2 pb-3'>
                        <div className='col-12 text-center'>
                            <h2 className='mb-4'>Previous data purchases</h2>
                            <ResponsiveTable data={this.state.previousDataPurchases} />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default BuyUsageData



// WEBPACK FOOTER //
// ./resources/js/modules/BuyUsageData.js